import { throttle } from 'throttle-debounce';

export default class ResponsiveImages {
    constructor() {
        this.images = document.querySelectorAll('img[srcset].responsive-image');
        this.loadHandlers = new Map();
        
        this.initImages();
        this.setupResizeHandler();
    }

    initImages() {
        [...this.images].forEach(img => {
            this.updateImageSize(img);
            
            if (!img.complete) {
                img.classList.add('blur');
                
                const loadHandler = (e) => {
                    e.target.classList.remove('blur');
                    e.target.classList.add('loaded');
                    this.loadHandlers.delete(img);
                };
                
                this.loadHandlers.set(img, loadHandler);
                img.addEventListener('load', loadHandler, { once: true });
            }
        });
    }

    updateImageSize(img) {
        if (img && img.offsetWidth) {
            img.sizes = img.offsetWidth + 'px';
        }
    }

    setupResizeHandler() {
        this.resizeHandler = throttle(250, () => {
            [...this.images].forEach(img => this.updateImageSize(img));
        });
        
        window.addEventListener('resize', this.resizeHandler);
    }

    destroy() {
        // Clean up event listeners
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
        
        // Clean up any remaining load handlers
        this.loadHandlers.forEach((handler, img) => {
            img.removeEventListener('load', handler);
        });
        this.loadHandlers.clear();
    }
}